import React from "react";
import "./About.css";

const About = () => {
  /* const lang = localStorage.getItem("lang") === "bn" ? "bn" : "en"; */

  return (
    <div className="about-container">
      <div className="about-card">
        <h1 className="about-title">Who We Are</h1>
        <div className="about-description">
          Innovative software solutions designed to transform and elevate your
          business processes in the digital world.
        </div>
      </div>
      <div className="about-card">
        <h1 className="about-title">About Nuqisoft</h1>
        <div className="about-description">
          We develop high quality mobile and desktop apps based in London, UK.
          Right now we’re building highly effective, user-friendly apps to help
          people pass their UK driving theory test. Our goal is to provide our
          users with the best possible software solution at the lowest possible
          price. so that our users can be as prepared as possible for their
          driving theory test!
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
        <div className="about-card">
          <h1 className="about-title">Our Vision</h1>
          <div className="about-description">
            To revolutionise how businesses leverage technology for sustained
            growth and efficiency in an ever-evolving digital landscape.
          </div>
        </div>
        <div className="about-card">
          <h1 className="about-title">Our Mission</h1>
          <div className="about-description">
            To deliver exceptional, user-friendly software solutions that
            empower businesses to optimise their operations and thrive
            competitively.
          </div>
        </div>
      </div>
      <div className="about-card">
        <h1 className="about-title">Driving Theory Test Bangla</h1>
        <div className="about-description">
          Are you a Bangla speaker living in the UK and preparing for your car,
          motorcycle, or HGV/LGV theory test? Look no further! Our Driving
          Theory Test UK – Bangla Edition app is specially designed for the
          Bangladeshi community in the UK, offering fully translated questions,
          answers, and explanations in Bangla (Bengali) to help you pass your
          test with confidence.
        </div>
      </div>
      <div className="about-row">
        <div className="about-card" style={{ width: "50%" }}>
          <h1 className="about-title">App Features</h1>
          <div className="about-description">
            <ul>
              <li>
                <strong>DVSA-Licensed Questions:</strong> Practice every
                official revision question, case study, and hazard perception
                video licensed directly from the DVSA – the people who set the
                test.
              </li>
              <li>
                <strong>Bangla Translations:</strong> Every question, answer,
                and explanation is professionally translated into Bangla – ideal
                for those who feel more comfortable revising in their native
                language.
              </li>
              <li>
                <strong>Hazard Perception Practice:</strong> Includes 80+
                interactive CGI hazard perception clips with guidance in Bangla
                so you know exactly what to look for.
              </li>
              <li>
                <strong>Mock Tests & Progress Tracking:</strong> Simulate the
                real test experience with unlimited mock tests. Track your
                progress to see where you need improvement – all in Bangla.
              </li>
              <li>
                <strong>Theory for All Vehicles:</strong> Prepare for car,
                motorcycle, LGV, and PCV tests – all in one app.
              </li>
              <li>
                <strong>Study Anytime, Anywhere:</strong> Whether you’re using
                an iPhone, iPad, Android phone, or tablet, our app is fully
                compatible across all major devices.
              </li>
            </ul>
          </div>
        </div>
        <div className="about-app-images">
          <img
            style={{ width: "50%" }}
            src="/Assets/DTTB_en-portrait.png"
            alt="Logo"
            className="about-logo"
          />
          <img
            style={{ width: "50%" }}
            src="/Assets/DTTB-portrait.png"
            alt="Logo"
            className="about-logo"
          />
        </div>
      </div>
    </div>
  );
};

export default About;
